(() => {
  const root = document.querySelector('.nom-elevate');

  if (root) {
    const desktopQuery = window.matchMedia('(min-width: 768px)');
    const tabs = [...root.querySelectorAll('[data-elevate-tab]')];
    const productsPanel = root.querySelector('[data-elevate-products]');
    const merchPanel = root.querySelector('[data-elevate-merch]');
    const productCards = [...root.querySelectorAll('[data-elevate-product]')];
    let activeCategory = 'all';

    const renderCategory = () => {
      const isDesktop = desktopQuery.matches;

      tabs.forEach((tab) => {
        const selected = tab.dataset.elevateTab === activeCategory;
        tab.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (!isDesktop) {
        productsPanel.hidden = false;
        merchPanel.hidden = false;
        merchPanel.removeAttribute('data-elevate-visible');
        productCards.forEach((card) => { card.hidden = false; });
        return;
      }

      const merchSelected = activeCategory === 'merch';
      productsPanel.hidden = merchSelected;
      merchPanel.hidden = !merchSelected;
      if (merchSelected) {
        merchPanel.setAttribute('data-elevate-visible', 'true');
      } else {
        merchPanel.removeAttribute('data-elevate-visible');
      }
      productCards.forEach((card) => {
        card.hidden = activeCategory === 'superlattes' && card.dataset.elevateCategory !== 'superlattes';
      });
    };

    tabs.forEach((tab, tabIndex) => {
      tab.addEventListener('click', () => {
        activeCategory = tab.dataset.elevateTab;
        renderCategory();
      });

      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = tabIndex;
        if (event.key === 'ArrowLeft') nextIndex = (tabIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (tabIndex + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        tabs[nextIndex].focus();
        tabs[nextIndex].click();
      });
    });

    desktopQuery.addEventListener('change', renderCategory);
    renderCategory();
  }
})();
